module.exports = __webpack_public_path__ + "static/img/xjsq.9bd4ac87.png";